import React from 'react';
import { Card, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const SubscriptionProblemAlert = () => {
  const { t } = useTranslation();

  return (
    <Card 
      style={{ 
        marginBottom: '32px',
        border: '1px solid #ffccc7',
        backgroundColor: '#fff2f0'
      }}
      data-testid="subscription-problem-alert"
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <InfoCircleOutlined style={{ color: '#ff4d4f', fontSize: '20px' }} />
        <Text strong style={{ color: '#ff4d4f', fontSize: '16px' }}>
          {t('subscription.problem_message', 'There is an issue with your subscription. Please update your payment method to continue using our services.')}
        </Text>
      </div>
    </Card>
  );
};

export default SubscriptionProblemAlert; 